
export const memberships = [
  {
    id: 1,
    name: 'International Spa Association',
    logo: 'https://public.readdy.ai/ai/img_res/933a86f114908d7e17c3507b1ab6a09a.jpg'
  },
  {
    id: 2,
    name: 'Professional Beauty Association',
    logo: 'https://readdy.ai/api/search-image?query=professional%20beauty%20association%20logo%20industry%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem2&orientation=landscape'
  },
  {
    id: 3,
    name: 'Medical Equipment Suppliers',
    logo: 'https://readdy.ai/api/search-image?query=medical%20equipment%20suppliers%20association%20logo%20healthcare%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem3&orientation=landscape'
  },
  {
    id: 4,
    name: 'Chamber of Commerce',
    logo: 'https://readdy.ai/api/search-image?query=chamber%20of%20commerce%20logo%20business%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem4&orientation=landscape'
  },
  {
    id: 5,
    name: 'Quality Assurance Council',
    logo: 'https://readdy.ai/api/search-image?query=quality%20assurance%20council%20logo%20certification%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem5&orientation=landscape'
  },
  {
    id: 6,
    name: 'Healthcare Products Association',
    logo: 'https://readdy.ai/api/search-image?query=healthcare%20products%20association%20logo%20medical%20industry%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem6&orientation=landscape'
  },
  {
    id: 7,
    name: 'Salon & Spa Alliance',
    logo: 'https://readdy.ai/api/search-image?query=salon%20spa%20alliance%20logo%20beauty%20industry%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem7&orientation=landscape'
  },
  {
    id: 8,
    name: 'International Trade Council',
    logo: 'https://readdy.ai/api/search-image?query=international%20trade%20council%20logo%20business%20organization%20emblem%20clean%20design%20simple%20background&width=300&height=200&seq=mem8&orientation=landscape'
  }
];
